import Swiper from 'swiper/bundle';

$( function() {
	initTabsDesktop();
	initTabsMobile();

	if ($(window).width() < 576) {
		var swiper = new Swiper('.latest-news .swiper', {
			mousewheel: false,
			initialSlide: 0,
			grabCursor: true,
			centeredSlides: false,
			slidesPerView: '2',
			//autoHeight: true, //enable auto height [not working on vertical scroll]
			spaceBetween: 25,
		});
	}

});

function initTabsDesktop() {
	$('.tabs-title a:not(.active)').on('click', function(e) {
		e.preventDefault();
		$('.tabs-title a').not($(this)).removeClass('active');
		$(this).addClass('active');
		$('.tabs-content .tab').not($(this)).removeClass('active');
		$($(this).data('id')).addClass('active');
	});
	$('.tabs-title li:first-child a').addClass('active');
}

function initTabsMobile() {
	$('.tabs-content .mobile > a').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		var el = $(this).parent().next('.tab').find('.inner-mobile');
		var vis = el.is(":visible");
		el[ vis ? "slideUp" : "slideDown"]();
	});
}
